import {Button, Icon, Layout} from '@ui-kitten/components';
import React, {useState} from 'react';
import {Image, StyleSheet} from 'react-native';
import {px} from '../../utils';
import {SelectImageModal} from '../components';

const imgIcon = (props) => <Icon {...props} name="image-outline" />;
const delIcon = (props) => <Icon {...props} fill="red" name="trash-outline" />;

const ImagePicker = ({imageData, setImageData}) => {
  const [isSelectImageModalVisible, setIsSelectImageModalVisible] = useState(
    false,
  );

  return (
    <>
      <Button
        style={styles.button}
        status="basic"
        size="large"
        accessoryLeft={imgIcon}
        onPress={() => setIsSelectImageModalVisible(true)}>
        {'Add Image of Official Receipt'}
      </Button>
      <Layout style={styles.imageRow}>
        {imageData && (
          <>
            <Image style={styles.imageStyle} source={{uri: imageData.uri}} />
            <Button
              appearance="ghost"
              accessoryLeft={delIcon}
              onPress={() => setImageData(undefined)}
            />
          </>
        )}
      </Layout>
      <SelectImageModal
        setImageData={setImageData}
        onClose={() => setIsSelectImageModalVisible(false)}
        visible={isSelectImageModalVisible}
      />
    </>
  );
};

const styles = StyleSheet.create({
  marginTop: {
    marginTop: px(20),
  },
  button: {
    marginTop: px(20),
    height: px(80),
  },
  imageRow: {
    marginTop: px(10),
    marginHorizontal: px(15),
    flexDirection: 'row',
    height: 100,
  },
  imageStyle: {
    width: 100,
    height: 100,
  },
});

export default ImagePicker;
